/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ViolationTypeEnum } from './ViolationTypeEnum';
import {
    ViolationTypeEnumFromJSON,
    ViolationTypeEnumFromJSONTyped,
    ViolationTypeEnumToJSON,
    ViolationTypeEnumToJSONTyped,
} from './ViolationTypeEnum';

/**
 * 
 * @export
 * @interface ViolationCreate
 */
export interface ViolationCreate {
    /**
     * 
     * @type {number}
     * @memberof ViolationCreate
     */
    partyId?: number | null;
    /**
     * Specific violation section or rule
     * @type {ViolationTypeEnum}
     * @memberof ViolationCreate
     */
    type: ViolationTypeEnum;
    /**
     * Description of how this violation occurred
     * @type {string}
     * @memberof ViolationCreate
     */
    description: string;
    /**
     * Whether this is an established violation (True) or alleged violation (False)
     * @type {boolean}
     * @memberof ViolationCreate
     */
    isEstablished?: boolean;
}



/**
 * Check if a given object implements the ViolationCreate interface.
 */
export function instanceOfViolationCreate(value: object): value is ViolationCreate {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ViolationCreateFromJSON(json: any): ViolationCreate {
    return ViolationCreateFromJSONTyped(json, false);
}

export function ViolationCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViolationCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'partyId': json['party_id'] == null ? undefined : json['party_id'],
        'type': ViolationTypeEnumFromJSON(json['type']),
        'description': json['description'],
        'isEstablished': json['is_established'] == null ? undefined : json['is_established'],
    };
}

export function ViolationCreateToJSON(json: any): ViolationCreate {
    return ViolationCreateToJSONTyped(json, false);
}

export function ViolationCreateToJSONTyped(value?: ViolationCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'party_id': value['partyId'],
        'type': ViolationTypeEnumToJSON(value['type']),
        'description': value['description'],
        'is_established': value['isEstablished'],
    };
}

